import * as React from "react";
import { useTagColumns } from "./useTagColumns";
import { TableColumn } from "../../types";

export function useColumnsWithTagColumns<TData extends { tags?: Record<string, any> }>(
  baseColumns: TableColumn<TData>[],
  resourceType: string,
): TableColumn<TData>[] {
  const tagColumns = useTagColumns<TData>(resourceType);

  return React.useMemo(() => {
    if (tagColumns.length === 0) {
      return baseColumns;
    }

    const result = [...baseColumns];

    // Insert before the Tags column (id: "tags"), or before Created (id: "created"), or append at end
    let insertIndex = result.findIndex((col) => col.id === "tags");
    if (insertIndex === -1) {
      insertIndex = result.findIndex((col) => col.id === "created");
    }
    if (insertIndex === -1) {
      insertIndex = result.length;
    }

    result.splice(insertIndex, 0, ...tagColumns);
    return result;
  }, [baseColumns, tagColumns]);
}
